import React from 'react';
import {
  Control,
} from 'react-hook-form';
import clsx from 'clsx';
import isNil from 'lodash/isNil';
import {
  Controller,
} from 'core/components/FormController';
import SwitchButton from 'core/components/Switch';
import {
  DEFAULT_EMPTY_VALUE,
} from 'core/constants';
import {
  RTMProviderThresholdsDTO,
} from 'dtos';
import ThresholdOptionGroup from 'pages/Dashboard/pages/Dashboard/RTM/ThresholdSettings/ThresholdOptionGroup';
import {
  ThresholdRowConfig,
} from 'pages/Dashboard/pages/Dashboard/RTM/ThresholdSettings/thresholdUiConfig';

type Props = {
  row: ThresholdRowConfig;
  control: Control<RTMProviderThresholdsDTO>;
  gridClassName: string;
};

export default function ThresholdSignalRow({ row, control, gridClassName }: Props) {
  return (
    <div
      className={clsx(
        gridClassName,
        'items-center border-b border-gray-100 px-3 py-4 last:border-b-0',
        { 'bg-red-50 rounded-t-md': row.tone === 'alert' },
      )}
    >
      <div className="w-36 shrink-0 min-w-0">
        <p className="text-sm font-semibold text-gray-900">{row.title}</p>
        <p className="text-xs text-gray-500">{row.description}</p>
      </div>
      <div className="min-w-0 flex-1">
        {!isNil(row.keys.watch) ? (
          <Controller
            name={row.keys.watch}
            control={control}
            render={({ field }) => (
              <ThresholdOptionGroup
                value={Number(field.value)}
                options={row.watchOptions ?? []}
                variant="watch"
                onChange={field.onChange}
              />
            )}
          />
        ) : (
          <span className="text-sm text-gray-700">{DEFAULT_EMPTY_VALUE}</span>
        )}
      </div>
      <div className="min-w-0 flex-1">
        {row.inputType === 'fixedNeedsReview' ? (
          !isNil(row.keys.needsReview) && (
            <Controller
              name={row.keys.needsReview}
              control={control}
              render={({ field }) => (
                <SwitchButton
                  checked={Boolean(field.value)}
                  onChange={(_, checked) => { field.onChange(checked); }}
                  color="primary"
                />
              )}
            />
          )
        ) : (
          !isNil(row.keys.needsReview) && (
            <Controller
              name={row.keys.needsReview}
              control={control}
              render={({ field }) => (
                <ThresholdOptionGroup
                  value={Number(field.value)}
                  options={row.needsReviewOptions ?? []}
                  variant="needsReview"
                  onChange={field.onChange}
                />
              )}
            />
          )
        )}
      </div>
    </div>
  );
}
